module.exports = __webpack_public_path__ + "media/images/vip-040625ed58445e824624cb5fc99c93bf.png";